import React from 'react';
import CsvDownloader from 'react-csv-downloader';

import { Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { ICSVColumn } from '~/src/dash/views/dashboards/DashboardHome/sections/DashboardOverview/CSVDownloadButton';

interface IProps {
  columns: ICSVColumn[];
  datas: () => Promise<Record<string, any>[]>;
  filename: string;
  isDisabled: boolean;
  title: string;
}

// IMPORTANT: This is custom to forecasting. Do not copy and paste.
export const ForecastCSVDownloadButton = ({
  columns,
  datas,
  filename,
  isDisabled,
  title,
}: IProps) => {
  return (
    <CsvDownloader
      columns={columns}
      datas={datas}
      filename={filename}
      extension='.csv'
      separator=';'
      disabled={isDisabled}
      title={title}
      meta={true}
    >
      <Text extraSmall color={isDisabled ? publicaColors.gray : publicaColors.blue}>
        Download CSV
      </Text>
    </CsvDownloader>
  );
};
